export const recruiterDashboardConstants = {
    // GET_ALL Candidates
    GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST:
      "GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST",
    GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS:
      "GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS",
    GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE:
      "GET_ALL_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE",
  
    
  };
  